import { render, staticRenderFns } from "./AddPurchaseOffersQuickentryStockLineForm.vue?vue&type=template&id=195a60d4&"
import script from "./AddPurchaseOffersQuickentryStockLineForm.vue?vue&type=script&lang=js&"
export * from "./AddPurchaseOffersQuickentryStockLineForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports